import clsx from "clsx";

import { type CommonProps } from "@/types";
import { createId, formatCurrency } from "@/utils/helpers";

import styles from "./Price.module.css";

const ref = "price";

interface PriceProps extends Partial<CommonProps> {
  amount: number;
  baseline?: boolean;
}

function usePrice(props: PriceProps) {
  const className = clsx(styles[ref], props.className);
  const { amount = 0, baseline = false, id = createId(ref) } = props;

  return {
    amount: baseline ? Math.round(amount) : amount,
    baseline,
    className,
    id,
  };
}

function Price(props: PriceProps) {
  const { amount, baseline, className, id } = usePrice(props);

  return (
    <section className={className} id={id}>
      {baseline && <span>From</span>}
      <p>
        <span className={styles.amount}>{formatCurrency(amount)}</span>
        pp
      </p>
    </section>
  );
}

export default Price;
export { Price, type PriceProps };
